import React from 'react';

import OnboardingTour from './OnboardingTour';
import {
  TXTCLI_Exit_Tour,
  TXTCLI_Good_luck_and_have_funX,
  TXTCLI_YOUXRE_ALL_SETX
} from './OnboardingTourEnd.messages.json';

const OnboardingTourEnd: React.FC = () => (
  <OnboardingTour
    heading={TXTCLI_YOUXRE_ALL_SETX}
    text={TXTCLI_Good_luck_and_have_funX}
    primaryButtonText={TXTCLI_Exit_Tour}
    hideSecondaryButton
  />
);

export default OnboardingTourEnd;
